// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  navigation: {
    name: 'mobileNav',
    componentName: 'MobileNav',
    chunk: () =>
      import(
        /* webpackChunkName: "mobileNav" */
        './pages/MobileNav'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/MobileNav.tsx'),
          ).MobileNav
        : currentRouteName === 'mobileNav'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.MobileNav,
              })),
            );
    },
    path: '/:context?/myaccount/profile/menu',
    channel: null,
  },
  closeAccount: {
    name: 'closeAccountPage',
    componentName: 'CloseAccountPage',
    chunk: () =>
      import(
        /* webpackChunkName: "closeAccountPage" */
        './pages/CloseAccountPage'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/CloseAccountPage.tsx'),
          ).CloseAccountPage
        : currentRouteName === 'closeAccountPage'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.CloseAccountPage,
              })),
            );
    },
    path: '/:context?/myaccount/profile/closeAccount',
    channel: null,
  },
  home: {
    name: 'profilePage',
    componentName: 'ProfilePage',
    chunk: () =>
      import(
        /* webpackChunkName: "profilePage" */
        './pages/ProfilePage'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/ProfilePage.tsx'),
          ).ProfilePage
        : currentRouteName === 'profilePage'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.ProfilePage,
              })),
            );
    },
    path: '/:context?/myaccount/profile',
    channel: null,
  },
  addManageUsers: {
    name: 'addManageUsersPage',
    componentName: 'AddManageUsersPage',
    chunk: () =>
      import(
        /* webpackChunkName: "addManageUsersPage" */
        './pages/AddManageUsersPage'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/AddManageUsersPage.tsx'),
          ).AddManageUsersPage
        : currentRouteName === 'addManageUsersPage'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.AddManageUsersPage,
              })),
            );
    },
    path: '/:context?/myaccount/addmanageusers',
    channel: null,
  },
  dashboard: {
    name: 'dashboardPage',
    componentName: 'DashboardPage',
    chunk: () =>
      import(
        /* webpackChunkName: "dashboardPage" */
        './pages/DashboardPage'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/DashboardPage.tsx'),
          ).DashboardPage
        : currentRouteName === 'dashboardPage'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.DashboardPage,
              })),
            );
    },
    path: '/:context?/myaccount/dashboard',
    channel: null,
  },
});
